import React, { useEffect, useState } from "react";
import filteringProps from "../filtering/brandmodels.json";
import { getUser, hasRole, setPage, toPrettyDate, useHub, validateRole } from "../../../core/Global";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { Link } from "react-router-dom";
import { DataTable, DataTableField } from "../../../components/data/DataTable";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import TextBox from "../../../components/form/TextBox";
import { toastSuccess } from "../../../components/base/Toast";
import TextArea from "../../../components/form/TextArea";
import DropDown from "../../../components/form/DropDown";
import Tagify from "../../../components/tagify/Tagify";
import { BrandSubModel } from "../models/BrandSubModel";
import { DrawerForm } from "../../../components/drawers/DrawerForm";

export default function BrandModelsListView() {

  const hub = useHub()
  const user = getUser()

  const [createModal, createModalSet] = useState<boolean>(false)
  const [editModal, editModalSet] = useState<boolean>(false)
  const [deleteModal, deleteModalSet] = useState<boolean>(false)
  const [deleteRes, deleteResSet] = useState<any>(true)

  const [selectedItem, selectedItemSet] = useState<BrandSubModel>()
  const [selectedVendorId, selectedVendorIdSet] = useState<string>()


  const [refresh, refreshSet] = useState<boolean>();

  const edit = (data: BrandSubModel) => {
    selectedItemSet(data);
    editModalSet(true);
    selectedVendorIdSet(data.vendorId);
  }

  const deleteModel = (data: any) => {
    selectedItemSet(data);
    deleteModalSet(true);
  }


  const NameItem = (data: BrandSubModel) => (
    <FlexRow onClick={() => edit(data)}>
      <div className="ms-2">
        {data.name}
      </div>
      <a href="#" className="ms-1"
        onClick={e => {
          e.preventDefault();
          edit(data);
        }}>
        <Icon icon="edit" className="ms-2" size={12} />
      </a>
    </FlexRow>
  )

  const VendorItem = (data: BrandSubModel) => (
    <FlexRow>
      <div>
        {data.vendor?.name}
      </div>
    </FlexRow>
  )

  const BrandItem = (data: BrandSubModel) => (
    <FlexRow>
      <div>
        <img src={data.brand?.logoUrl} className="w-25px" />
      </div>
      <div className="ms-2">
        {data.brand?.name}
      </div>
    </FlexRow>
  )

  const CreatedItem = (data: BrandSubModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  const ModifiedItem = (data: BrandSubModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.modifiedAt)}
      </div>
      {
        data.modifiedUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.modifiedUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  useEffect(() => {

    validateRole("ManageBrandModels");
    setPage("Models", "Inventory", "Base Data");

  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])

  return (
    <>

        <DataTable
          objectName="Model"
          apiRoute={API_ROUTES.InventoryBrandsModels}
          filteringProps={filteringProps}
          // sortingProps={sortingProps}
          addCustom={() => {
            createModalSet(true)
            selectedVendorIdSet(undefined)
          }}
          edit editCustom={edit}
          delete={hasRole("DeleteBrandModels")} deleteCustom={deleteModel}
          refresh={refresh}>

          <DataTableField title="Name">
            <NameItem />
          </DataTableField>

          <DataTableField title="Brand">
            <BrandItem />
          </DataTableField>

          <DataTableField title="Vendor">
            <VendorItem />
          </DataTableField>

          <DataTableField title="Description" dataValueName="description" />

          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

          <DataTableField title="Modified">
            <ModifiedItem />
          </DataTableField>

        </DataTable>




      {
        createModal &&
        <DrawerForm id="drawer-add-brandmodel"
          title="Create Model"
          buttonText="Add Model(s)"
          onClose={() => {
            createModalSet(false)
            selectedVendorIdSet(undefined)
          }}
          focusOn="add-brandmodel-name"
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.names) || body.names.length < 2) {
              window.formError("names", "Please write a valid name!", "modal-add-brandmodel", true);
              if (callback) callback();
              return;
            }

            hub.Post(API_ROUTES.InventoryBrandsModels, body, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Model(s) has been added successfully!");
              }
              if (callback) callback(res);
            })

          }}>
          <div>

            <DropDown id="add-brandmodel-vendors" name="vendorId"
              label="Vendor" labelUp block onSelect={e => selectedVendorIdSet(e)}
              apiSource={`${API_ROUTES.InventoryVendors}all`} />

            <DropDown id={`add-brandmodel-brands-${selectedVendorId}`} name="brandId"
              key={`add-brandmodel-brands-${selectedVendorId}`} labelUp block label="Brand"
              apiSource={`${API_ROUTES.InventoryBrands}all/?vendorId=${selectedVendorId}`} />

            <Tagify id="create-model-names" name="names" label="Name(s)" marginBottom={5}
              parentId="modal-add-brandmodel" labelUp block freeTags />

            <TextArea id="add-brandmodel-descr" name="description"
              label="Description" labelUp block rows={6}
              placeholder="Write a description (optional)" />

          </div>
        </DrawerForm>
      }


      {
        editModal && selectedItem &&
        <DrawerForm id="modal-edit-brandmodel"
          title="Edit Model"
          buttonText="Update Model"
          onClose={() => {
            editModalSet(false);
            selectedItemSet(undefined);
            selectedVendorIdSet(undefined);
          }}
          focusOn="edit-brandmodel-name"
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "modal-edit-brandmodel", true);
              if (callback) callback();
              return;
            }

            hub.Put(API_ROUTES.InventoryBrandsModels, {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Model has been updated successfully!");
              }
              if (callback) callback(res);
            })

          }}>

          <div>

            <DropDown id="add-brandmodel-vendors" name="vendorId"
              label="Vendor" labelUp block onSelect={e => selectedVendorIdSet(e)}
              forceSelectValue={selectedItem.vendorId}
              apiSource={`${API_ROUTES.InventoryVendors}all`} />

            <DropDown id={`add-brandmodel-brands-${selectedVendorId}`} name="brandId"
              key={`add-brandmodel-brands-${selectedVendorId}`} labelUp block label="Brand"
              forceSelectValue={selectedItem.brandId}
              apiSource={`${API_ROUTES.InventoryBrands}all/?vendorId=${selectedVendorId}`} />

            <TextBox id="edit-brandmodel-name" name="name" label="Name" marginBottom={5}
              labelUp block value={selectedItem.name} />

            <TextArea id="edit-brandmodel-descr" name="description"
              label="Description" labelUp block rows={6} value={selectedItem.description}
              placeholder="Write a description (optional)" />

          </div>

        </DrawerForm>
      }


      {
        deleteModal && selectedItem &&
        <Modal id="modal-delete-brandmodel"
          title="Delete Model"
          buttonText="Confirm & Delete"
          buttonColor="danger"
          onOpen={() => {
            // hub.Post(API_ROUTES.InventoryCategories + "verifydelete", {
            //   id: selectedItem.id
            // }, res => deleteResSet(res.data))
          }}
          onClose={() => {
            deleteModalSet(false)
            //deleteResSet(undefined)
            selectedItemSet(undefined)
          }}
          onSubmit={deleteRes ? (body, callback) => {

            hub.Post(API_ROUTES.InventoryBrandsModels + "delete", {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Model has been deleted successfully!");
              }
              if (callback) callback(res);
            })

          } : undefined}
          staticBackdrop open visible>
          <div>
            <div className="mb-2">
              Are you sure you want to delete the model?
            </div>
            <div className="alert alert-danger">
              {selectedItem.name}
            </div>

          </div>
        </Modal>
      }


    </>
  );
}
